
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-kepala-skb/tim-kinerja/pelaksanaan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-kepala-skb/tim-kinerja/pelaksanaan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-kepala-skb/tim-kinerja/pelaksanaan"])
      });
    }
  